import React, { useState } from 'react';

export const Dialog = ({ children, open, onOpenChange }) => (
  <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center ${open ? '' : 'hidden'}`}>
    {children}
  </div>
);

export const DialogTrigger = ({ children, onClick }) => (
  <button onClick={onClick}>{children}</button>
);

export const DialogContent = ({ children, ...props }) => (
  <div className="bg-white p-6 rounded shadow" {...props}>
    {children}
  </div>
);

export const DialogHeader = ({ children, ...props }) => (
  <div className="border-b pb-2 mb-4" {...props}>
    {children}
  </div>
);

export const DialogTitle = ({ children, className = '', ...props }) => (
  <h3 className={`text-lg font-bold ${className}`} {...props}>
    {children}
  </h3>
);
